export default __webpack_public_path__ + "static/media/promo-text-new.0d21b435.svg";